var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhiteNavyBlueBgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#0B1A8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91876 4.1295C10.0603 4.34083 9.98794 4.49769 9.91876 4.59745L6.28932 9.92174C6.2547 9.97167 6.00853 10 5.95791 10C5.90728 10 5.85891 9.97167 5.82428 9.92174L4.10715 7.44557C3.96428 7.23174 3.96431 6.99538 4.10706 6.87931C4.23068 6.72525 4.49712 6.69149 4.59044 6.75847L6.0956 8.8525L9.38592 4.05719C9.55902 3.99021 9.7975 3.94852 9.91876 4.1295Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhiteNavyBlueBgCircle);
export default __webpack_public_path__ + "static/media/checkWhiteNavyBlueBgCircle.e7b95ad78c8ebf29601c9f0a33f0354c.svg";
export { ForwardRef as ReactComponent };